import React from "react";
import Camera from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";

const CameraComponent = ({ onTakePhoto }) => {
  return (
    <Camera
      onTakePhoto={onTakePhoto}
      isMaxResolution={true}
      // idealResolution={{ width: 1920, height: 1080 }}
      imageType="jpg"
      sizeFactor={0.5}
      isSilentMode={true}
      idealFacingMode="environment"
      sx={{
        position: "fixed",
        top: "0",
        left: "0",
        width: "100vw",
        heigth: "100vh",
      }}
    />
  );
};

export default CameraComponent;
